module.exports = __webpack_public_path__ + "img/grid-3.011babc0.svg";